/**
 * Shared scope-label strings for permission grants that carry both a public
 * (org-wide) and a private (creator-only) scoping. Used by both the
 * create-form grant row (`api-access-grant-row.tsx`) and the details-panel
 * label (`PermissionsValueLabel.tsx`) so the two surfaces cannot drift apart.
 */

export const SCOPE_LABEL_ALL_EXCEPT_PRIVATE = 'All records except private';
export const SCOPE_LABEL_ALL_INCLUDING_PRIVATE =
  'All records including private';
